export const GLOBAL = {
    url: 'https://siareg.guanajuato.gob.mx/api_siareg/',
    urlServer: 'https://siareg.guanajuato.gob.mx/'
};
